import React from 'react'
import { useTranslation } from 'react-i18next'
import noJobsImage from '../../../../assets/images/no_suggestion.svg'

const NoJobs = () => {
  const { t } = useTranslation(['common'], {
    useSuspense: false,
  })

  return (
    <div
      style={{
        display: 'flex',
        marginTop: '15vh',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
      }}
    >
      <img src={noJobsImage} alt="no jobs" style={{ height: '170px' }} />
      <p
        style={{
          textAlign: 'center',
          opacity: 0.8,
        }}
      >
        {t('common:noJob.update')}
      </p>
    </div>
  )
}

export default NoJobs
